import {
  Box,
  BoxProps,
  createStyles,
  fade,
  withStyles,
} from '@material-ui/core';
import React from 'react';
import { Tooltip } from '@devexpress/dx-react-chart-material-ui';
import { black } from './colors';
import { formatDate, getCurrency } from './utils';

export const FsChartTooltipArrow = withStyles(() =>
  createStyles({
    root: {},
  })
)((props: BoxProps) => (
  <Box
    {...props}
    height={8}
    style={{
      position: 'relative',
      overflow: 'hidden',
      transform: `translateY(10px)`,
    }}
  >
    <Box
      width={10}
      height={10}
      style={{
        position: 'absolute',
        top: 0,
        left: '50%',
        transform: 'translate(-50%, -50%) rotate(45deg)',
        backgroundColor: black,
        boxShadow: `0px 1px 2px ${fade(black, 0.5)}`,
      }}
    />
  </Box>
));

interface FsChartTooltipContentProps {
  coreProps: Tooltip.ContentProps;
  x: number;
  format?: string;
  currency?: string;
  label?: string;
}

export const FsChartTooltipContent = withStyles(() =>
  createStyles({
    root: {},
  })
)(({ coreProps, x, format, currency, label }: FsChartTooltipContentProps) => {
  const { text } = coreProps;
  const value = parseFloat(text);
  return (
    <>
      <Tooltip.Content
        {...coreProps}
        text={
          currency && format
            ? `Value: ${getCurrency({ currency, format, value })}`
            : `${value} ${label || ''}`
        }
      />
      <Box height="1px" bgcolor="rgba(255, 255, 255, 0.2)" />
      <Tooltip.Content {...coreProps} text={`Date: ${formatDate(x)}`} />
    </>
  );
});
